import { ChangeEvent, useState } from 'react';
import { useAprioriStore } from '../dal/apriori-store';
import { IAprioriParameters } from '../apriori-interfaces';
import { jsonStringify } from '../../../../../domain/openu-provider';
import { toJson } from '../domain/text-preprocess';
import {
    getAprioriTableDataStorage,
    saveAprioriJsonToStorage,
    saveAprioriTableDataToStorage
} from '../dal/apriori-storage';

const AprioriParameters = () => {

    const params = useAprioriStore(store => store.params);
    const setParams = useAprioriStore(store => store.setParams);

    const [tableData, setTableData] = useState(getAprioriTableDataStorage());
    const [tableDataJson, setTableDataJson] = useState('');

    const onParametersChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        const value = evt.target.value;

        let parsed: IAprioriParameters|null = null;

        try{
            parsed = JSON.parse(value);
        }
        catch(err){
            console.log(err);
        }

        if(!parsed) return;

        setParams(parsed);
        saveAprioriJsonToStorage(JSON.stringify(parsed));
    };

    const onTableDataChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        const value = evt.target.value;
        setTableData(value);
        saveAprioriTableDataToStorage(value);
    };

    const toJsonClick = () => {
        const res = toJson(tableData);
        setTableDataJson(res);
        saveAprioriTableDataToStorage(tableData);
    };

    return (
        <div className="" style={{
            width: '300px',
        }}>
            <div className="mb-1 font-bold">JSON</div>

            <textarea
                className="border flex-1 p-2 mb-4 w-full"
                onChange={ onParametersChange }
                value={ jsonStringify(params) }
                style={{
                    height: '300px',
                }}
            />

            <div className="mb-1 font-bold">Table Data to Parse</div>

            <textarea
                className="border flex-1 p-2 w-full"
                onChange={ onTableDataChange }
                value={ tableData }
                style={{
                    height: '300px',
                }}
            />

            <button
                onClick={ toJsonClick }
                className="px-4 py-2 rounded bg-stone-100 border mt-px w-full"
                type="button">
                To Json
            </button>

            <div className="my-4 whitespace-pre-wrap">
                { tableDataJson }
            </div>
        </div>
    )
};

export default AprioriParameters;